import { generateHVACMockup } from './templates/hvac.js';
import { generateRoofingMockup } from './templates/roofing.js';
import { generateAutomotiveMockup } from './templates/automotive.js';
import { generateLandscapingMockup } from './templates/landscaping.js';
import { generateElectricalMockup } from './templates/electrical.js';

const IMAGES = 'https://semdeckdigital.github.io/semdeck-claude-mockups/images';

// Raw HTML for each template (index.html only, adapted with PLACEHOLDER_ tokens)
// generateMockup() applies all substitutions at call time.

const T1 = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="robots" content="noindex, nofollow">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>PLACEHOLDER_COMPANY | Precision CNC Machining &amp; Fabrication</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow:wght@300;400;500;600&family=Barlow+Condensed:wght@400;500;600;700&display=swap" rel="stylesheet">
  <style>
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    :root {
      --black: #060606; --dark: #0d0d0d; --card: #121212; --border: #1d1d1d;
      --forge: #c8860a; --forge-bright: #e09c18; --forge-dim: rgba(200,134,10,0.10);
      --cream: #ede5d5; --muted: #a0968a; --text: #c0b8aa;
    }
    PLACEHOLDER_BRAND_COLORS_T1
    html { scroll-behavior: smooth; }
    body { background: var(--black); color: var(--text); font-family: 'Barlow', sans-serif; font-size: 16px; line-height: 1.65; }
    body::before { content: ''; position: fixed; inset: 0; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E"); opacity: 0.025; pointer-events: none; z-index: 9999; }
    @keyframes fadeUp { from { opacity: 0; transform: translateY(32px); } to { opacity: 1; transform: translateY(0); } }
    .anim-1 { animation: fadeUp 0.8s cubic-bezier(0.22,1,0.36,1) 0.1s both; }
    .anim-2 { animation: fadeUp 0.8s cubic-bezier(0.22,1,0.36,1) 0.28s both; }
    .anim-3 { animation: fadeUp 0.8s cubic-bezier(0.22,1,0.36,1) 0.44s both; }
    .anim-4 { animation: fadeUp 0.8s cubic-bezier(0.22,1,0.36,1) 0.58s both; }
    nav { position: fixed; top: 0; left: 0; right: 0; z-index: 1000; background: rgba(6,6,6,0.92); backdrop-filter: blur(16px); border-bottom: 1px solid var(--border); padding: 0 52px; height: 76px; display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; }
    .nav-logo { justify-self: start; }
    .nav-logo img { height: 72px; width: auto; }
    .nav-logo-text { justify-self: start; font-family: 'Bebas Neue', sans-serif; font-size: 26px; color: var(--cream); letter-spacing: 0.04em; }
    .nav-links { display: flex; gap: 36px; list-style: none; justify-self: center; }
    .nav-links a { font-family: 'Barlow Condensed', sans-serif; font-size: 13px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; color: var(--muted); text-decoration: none; position: relative; padding-bottom: 4px; }
    .nav-links a::after { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 1px; background: var(--forge); transform: scaleX(0); transform-origin: left; transition: transform 0.28s ease; }
    .nav-links a:hover, .nav-links a.active { color: var(--cream); }
    .nav-links a:hover::after, .nav-links a.active::after { transform: scaleX(1); }
    .nav-right { justify-self: end; display: flex; align-items: center; gap: 24px; }
    .nav-phone { color: var(--muted); font-family: 'Barlow Condensed', sans-serif; font-size: 14px; letter-spacing: 0.08em; text-decoration: none; }
    .nav-phone:hover { color: var(--forge); }
    .btn-forge { background: var(--forge); color: #000; font-family: 'Barlow Condensed', sans-serif; font-weight: 700; font-size: 13px; letter-spacing: 0.14em; text-transform: uppercase; padding: 11px 24px; border: none; cursor: pointer; text-decoration: none; display: inline-block; }
    .btn-outline { background: transparent; color: var(--cream); font-family: 'Barlow Condensed', sans-serif; font-weight: 600; font-size: 13px; letter-spacing: 0.14em; text-transform: uppercase; padding: 11px 24px; border: 1px solid #2a2a2a; cursor: pointer; text-decoration: none; display: inline-block; }
    .hamburger { display: none; flex-direction: column; justify-content: center; gap: 5px; cursor: pointer; background: none; border: none; padding: 6px; }
    .hamburger span { display: block; width: 22px; height: 2px; background: var(--forge); }
    .hamburger.open span:nth-child(1) { transform: rotate(45deg) translate(5px, 5px); }
    .hamburger.open span:nth-child(2) { opacity: 0; width: 0; }
    .hamburger.open span:nth-child(3) { transform: rotate(-45deg) translate(5px, -5px); }
    .mobile-menu { display: none; position: fixed; top: 76px; left: 0; right: 0; z-index: 998; background: rgba(6,6,6,0.99); border-bottom: 1px solid #1d1d1d; flex-direction: column; }
    .mobile-menu.open { display: flex; }
    .mobile-menu a { font-family: 'Barlow Condensed', sans-serif; font-size: 16px; font-weight: 600; letter-spacing: 0.08em; color: #908078; text-decoration: none; padding: 16px 28px; border-bottom: 1px solid #181818; }
    .mobile-menu .mobile-cta { background: var(--forge); color: #000; font-weight: 700; text-align: center; }
    .hero { min-height: 100vh; position: relative; display: flex; align-items: center; padding: 120px 80px 100px; overflow: hidden; }
    .hero-bg { position: absolute; inset: 0; background-image: url('PLACEHOLDER_IMG/jelifer-maniago-O5rSp_U-Pa0-unsplash.jpg'); background-size: cover; background-position: center 40%; filter: brightness(0.20) saturate(0.5); }
    .hero-bg::after { content: ''; position: absolute; inset: 0; background: linear-gradient(105deg, rgba(6,6,6,0.75) 35%, transparent 100%); }
    .hero-ghost { position: absolute; right: -10px; bottom: -60px; font-family: 'Bebas Neue', sans-serif; font-size: clamp(180px, 24vw, 340px); color: transparent; -webkit-text-stroke: 1px rgba(200,134,10,0.055); letter-spacing: 0.02em; line-height: 1; pointer-events: none; user-select: none; }
    .hero-content { position: relative; z-index: 1; max-width: 720px; }
    .hero-eyebrow { font-family: 'Barlow Condensed', sans-serif; font-size: 12px; font-weight: 600; letter-spacing: 0.24em; text-transform: uppercase; color: var(--forge); margin-bottom: 18px; display: flex; align-items: center; gap: 14px; }
    .hero-eyebrow::before { content: ''; display: block; width: 38px; height: 1px; background: var(--forge); }
    .hero h1 { font-family: 'Bebas Neue', sans-serif; font-size: clamp(80px, 11vw, 148px); line-height: 0.88; color: var(--cream); letter-spacing: 0.01em; margin-bottom: 28px; }
    .hero h1 em { color: var(--forge); font-style: normal; }
    .hero-sub { font-size: 16px; color: #a09890; max-width: 480px; margin-bottom: 44px; line-height: 1.85; font-weight: 300; }
    .hero-ctas { display: flex; gap: 14px; flex-wrap: wrap; }
    .services { padding: 96px 80px 100px; background: var(--dark); }
    .section-tag { font-family: 'Barlow Condensed', sans-serif; font-size: 11px; font-weight: 700; letter-spacing: 0.26em; text-transform: uppercase; color: var(--forge); margin-bottom: 8px; }
    .section-header { margin-bottom: 52px; }
    .section-header h2 { font-family: 'Bebas Neue', sans-serif; font-size: clamp(48px, 6vw, 80px); color: var(--cream); letter-spacing: 0.02em; line-height: 0.95; margin-top: 4px; }
    .services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 2px; background: var(--border); }
    .service-card { background: var(--card); padding: 46px 38px; position: relative; overflow: hidden; transition: background 0.25s; }
    .service-card::before { content: ''; position: absolute; top: 0; left: 0; bottom: 0; width: 3px; background: linear-gradient(180deg, var(--forge) 0%, var(--forge-bright) 100%); transform: scaleY(0); transform-origin: top; transition: transform 0.35s cubic-bezier(0.22,1,0.36,1); }
    .service-card:hover { background: #161616; }
    .service-card:hover::before { transform: scaleY(1); }
    .service-num { font-family: 'Bebas Neue', sans-serif; font-size: 60px; color: rgba(200,134,10,0.09); line-height: 1; margin-bottom: 12px; letter-spacing: 0.02em; }
    .service-card h3 { font-family: 'Barlow Condensed', sans-serif; font-size: 20px; font-weight: 700; color: var(--cream); text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 12px; }
    .service-card p { font-size: 14px; color: #c0b4a0; line-height: 1.82; font-weight: 300; }
    .stats { background: var(--forge); padding: 52px 80px; display: grid; grid-template-columns: repeat(4, 1fr); }
    .stat { text-align: center; padding: 0 20px; border-right: 1px solid rgba(0,0,0,0.15); }
    .stat:last-child { border-right: none; }
    .stat-number { font-family: 'Bebas Neue', sans-serif; font-size: 68px; color: #000; line-height: 1; margin-bottom: 4px; letter-spacing: 0.02em; }
    .stat-label { font-family: 'Barlow Condensed', sans-serif; font-size: 12px; font-weight: 700; letter-spacing: 0.18em; text-transform: uppercase; color: rgba(0,0,0,0.45); }
    .about { padding: 100px 80px; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; background: var(--black); }
    .about-text .section-tag { margin-bottom: 10px; }
    .about-text h2 { font-family: 'Bebas Neue', sans-serif; font-size: clamp(44px, 5vw, 68px); color: var(--cream); letter-spacing: 0.02em; line-height: 0.92; margin-bottom: 26px; margin-top: 4px; }
    .about-text p { font-size: 15px; color: #b0a898; line-height: 1.88; margin-bottom: 14px; font-weight: 300; }
    .about-img-wrap { position: relative; }
    .about-img-wrap::before { content: ''; position: absolute; top: -18px; left: -18px; right: 18px; bottom: 18px; border: 1px solid rgba(200,134,10,0.25); z-index: 0; }
    .about-img-wrap::after { content: ''; position: absolute; top: -36px; left: -36px; right: 36px; bottom: 36px; border: 1px solid rgba(200,134,10,0.07); z-index: 0; }
    .about-img-wrap img { position: relative; z-index: 1; width: 100%; height: 500px; object-fit: cover; display: block; filter: brightness(0.75) saturate(0.65); }
    .contact { padding: 100px 80px; background: var(--dark); display: grid; grid-template-columns: 1fr 1.2fr; gap: 80px; align-items: start; }
    .contact-info h2 { font-family: 'Bebas Neue', sans-serif; font-size: clamp(42px, 4.5vw, 60px); color: var(--cream); letter-spacing: 0.02em; line-height: 0.92; margin-bottom: 20px; margin-top: 6px; }
    .contact-info p { font-size: 15px; color: #b0a898; line-height: 1.88; margin-bottom: 36px; font-weight: 300; }
    .contact-details { display: flex; flex-direction: column; gap: 18px; }
    .contact-item { display: flex; align-items: flex-start; gap: 14px; }
    .contact-item svg { width: 17px; height: 17px; color: var(--forge); flex-shrink: 0; margin-top: 3px; }
    .contact-item span, .contact-item a { font-size: 14px; color: #b8aea4; text-decoration: none; line-height: 1.65; }
    .contact-item a:hover { color: var(--forge); }
    .contact-form { display: flex; flex-direction: column; gap: 14px; }
    .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
    .field label { display: block; font-family: 'Barlow Condensed', sans-serif; font-size: 11px; font-weight: 700; letter-spacing: 0.20em; text-transform: uppercase; color: #9a8878; margin-bottom: 7px; }
    .field input, .field textarea, .field select { width: 100%; background: var(--card); border: 1px solid var(--border); color: var(--cream); font-family: 'Barlow', sans-serif; font-size: 14px; padding: 12px 15px; outline: none; appearance: none; }
    .field input::placeholder, .field textarea::placeholder { color: #2c2c2c; }
    .field textarea { resize: vertical; min-height: 112px; }
    .btn-submit { background: var(--forge); color: #000; font-family: 'Barlow Condensed', sans-serif; font-weight: 700; font-size: 14px; letter-spacing: 0.14em; text-transform: uppercase; padding: 16px; border: none; cursor: pointer; width: 100%; }
    footer { background: #030303; border-top: 1px solid var(--border); padding: 36px 80px; display: flex; align-items: center; justify-content: space-between; }
    footer img { height: 34px; }
    .footer-logo-text { font-family: 'Bebas Neue', sans-serif; font-size: 22px; color: var(--cream); letter-spacing: 0.04em; }
    .footer-copy { font-size: 12px; color: #706050; font-family: 'Barlow Condensed', sans-serif; letter-spacing: 0.06em; }
    @media (max-width: 900px) {
      nav { display: flex !important; justify-content: space-between; padding: 0 24px; }
      .nav-links { display: none !important; }
      .nav-phone { display: none; }
      .hamburger { display: flex; }
      .hero { padding: 100px 28px 70px; }
      .hero-ghost { display: none; }
      .services { padding: 70px 28px; }
      .services-grid { grid-template-columns: 1fr; background: none; gap: 2px; }
      .stats { grid-template-columns: 1fr 1fr; padding: 40px 28px; gap: 0; }
      .stat { border-right: none; border-bottom: 1px solid rgba(0,0,0,0.15); padding: 20px; }
      .about { padding: 70px 28px; grid-template-columns: 1fr; gap: 48px; }
      .about-img-wrap::before, .about-img-wrap::after { display: none; }
      .contact { padding: 70px 28px; grid-template-columns: 1fr; gap: 48px; }
      footer { padding: 28px; flex-direction: column; gap: 10px; text-align: center; }
      .form-row { grid-template-columns: 1fr; }
    }
  </style>
</head>
<body>
  <nav id="nav">
    PLACEHOLDER_NAV_LOGO
    <ul class="nav-links">
      <li><a href="#">Home</a></li>
      <li><a href="#about">About</a></li>
      <li><a href="#services">Services</a></li>
      <li><a href="#contact">Contact</a></li>
    </ul>
    <div class="nav-right">
      <a href="tel:PLACEHOLDER_PHONE_DIGITS" class="nav-phone">PLACEHOLDER_PHONE</a>
      <button class="hamburger" id="hamburger" aria-label="Open menu"><span></span><span></span><span></span></button>
      <a href="#contact" class="btn-forge">Get a Quote</a>
    </div>
  </nav>
  <div class="mobile-menu" id="mobile-menu">
    <a href="#">Home</a>
    <a href="#about">About</a>
    <a href="#services">Services</a>
    <a href="#contact">Contact</a>
    <a href="#contact" class="mobile-cta">Get a Quote</a>
  </div>
  <section class="hero">
    <div class="hero-bg"></div>
    <div class="hero-ghost">FORGE</div>
    <div class="hero-content">
      <div class="hero-eyebrow anim-1">PLACEHOLDER_HERO_EYEBROW</div>
      <h1 class="anim-2">PLACEHOLDER_HERO_H1</h1>
      <p class="hero-sub anim-3">PLACEHOLDER_HERO_TAGLINE</p>
      <div class="hero-ctas anim-4">
        <a href="#contact" class="btn-forge">Request a Quote</a>
        <a href="#services" class="btn-outline">Our Capabilities</a>
      </div>
    </div>
  </section>
  <section class="services" id="services">
    <div class="section-header">
      <div class="section-tag">What We Do</div>
      <h2>Machining<br>Capabilities</h2>
    </div>
    <div class="services-grid">
      PLACEHOLDER_SERVICE_CARDS_T1
    </div>
  </section>
  <div class="stats">
    <div class="stat"><div class="stat-number">25+</div><div class="stat-label">Years in Business</div></div>
    <div class="stat"><div class="stat-number">10K+</div><div class="stat-label">Parts Delivered</div></div>
    <div class="stat"><div class="stat-number">&#177;.001&quot;</div><div class="stat-label">Tolerance Held</div></div>
    <div class="stat"><div class="stat-number">100%</div><div class="stat-label">On-Time Delivery</div></div>
  </div>
  <section class="about" id="about">
    <div class="about-text">
      <div class="section-tag">About Us</div>
      <h2>Built on Precision.<br>Driven by Results.</h2>
      <p>PLACEHOLDER_ABOUT_PARA</p>
      <a href="#contact" class="btn-forge" style="margin-top:16px;display:inline-block;">Start a Project</a>
    </div>
    <div class="about-img-wrap">
      <img src="PLACEHOLDER_IMG/sven-daniel-eaanLTG7TCU-unsplash.jpg" alt="CNC machining in action">
    </div>
  </section>
  <section class="contact" id="contact">
    <div class="contact-info">
      <div class="section-tag">Get in Touch</div>
      <h2>Request<br>a Quote</h2>
      <p>Send us your print or describe your project. We'll get back to you within one business day with a quote and lead time.</p>
      <div class="contact-details">
        <div class="contact-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11 19.79 19.79 0 012 2.18 2 2 0 014 .18h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16z"/></svg><a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a></div>
        <div class="contact-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg><a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a></div>
        <div class="contact-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg><span>PLACEHOLDER_ADDRESS</span></div>
      </div>
    </div>
    <form class="contact-form">
      <div class="form-row">
        <div class="field"><label>First Name</label><input type="text" placeholder="John"></div>
        <div class="field"><label>Last Name</label><input type="text" placeholder="Smith"></div>
      </div>
      <div class="field"><label>Company</label><input type="text" placeholder="Your Company"></div>
      <div class="form-row">
        <div class="field"><label>Phone</label><input type="tel" placeholder="330-000-0000"></div>
        <div class="field"><label>Email</label><input type="email" placeholder="you@company.com"></div>
      </div>
      <div class="field"><label>Project Details</label><textarea placeholder="Describe your part, quantity, material, and tolerances..."></textarea></div>
      <button type="button" class="btn-submit">Send Quote Request &rarr;</button>
    </form>
  </section>
  <footer>
    PLACEHOLDER_FOOTER_LOGO_T1
    <div class="footer-copy">&copy; 2025 PLACEHOLDER_COMPANY. All rights reserved.</div>
  </footer>
  <script>
    var hamburger = document.getElementById('hamburger');
    var mobileMenu = document.getElementById('mobile-menu');
    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function() { hamburger.classList.toggle('open'); mobileMenu.classList.toggle('open'); });
      mobileMenu.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', function() { hamburger.classList.remove('open'); mobileMenu.classList.remove('open'); }); });
    }
  </script>
</body>
</html>`;

const T2 = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="robots" content="noindex, nofollow">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>PLACEHOLDER_COMPANY | CNC Machining &amp; Metal Fabrication</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Lato:wght@300;400;700;900&display=swap" rel="stylesheet">
  <style>
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    :root {
      --navy: #0e2540; --navy-mid: #163455; --navy-dark: #091a2e;
      --red: #c01c1c; --red-dark: #9e1515;
      --white: #ffffff; --cream: #f7f3ed; --cream-dark: #ede8e0; --border: #ddd7ce; --text: #2e2e2e; --muted: #6a6058;
    }
    PLACEHOLDER_BRAND_COLORS_T2
    html { scroll-behavior: smooth; }
    body { background: var(--white); color: var(--text); font-family: 'Lato', sans-serif; font-size: 16px; line-height: 1.65; }
    @keyframes fadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
    .anim-1 { animation: fadeUp 0.75s cubic-bezier(0.22,1,0.36,1) 0.1s both; }
    .anim-2 { animation: fadeUp 0.75s cubic-bezier(0.22,1,0.36,1) 0.28s both; }
    .anim-3 { animation: fadeUp 0.75s cubic-bezier(0.22,1,0.36,1) 0.44s both; }
    .anim-4 { animation: fadeUp 0.75s cubic-bezier(0.22,1,0.36,1) 0.58s both; }
    nav { position: fixed; top: 0; left: 0; right: 0; z-index: 1000; background: var(--white); border-bottom: 1px solid var(--border); padding: 0 52px; height: 76px; display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; box-shadow: 0 1px 20px rgba(14,37,64,0.06); }
    .nav-logo { justify-self: start; }
    .nav-logo img { height: 72px; width: auto; }
    .nav-logo-text { justify-self: start; font-family: 'Playfair Display', serif; font-size: 20px; font-weight: 800; color: var(--navy); }
    .nav-links { display: flex; gap: 40px; list-style: none; justify-self: center; }
    .nav-links a { font-family: 'Lato', sans-serif; font-size: 13px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: var(--navy); text-decoration: none; position: relative; padding-bottom: 4px; }
    .nav-links a::after { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: var(--red); transform: scaleX(0); transform-origin: left; transition: transform 0.25s ease; }
    .nav-links a:hover, .nav-links a.active { color: var(--red); }
    .nav-links a:hover::after, .nav-links a.active::after { transform: scaleX(1); }
    .nav-right { justify-self: end; display: flex; align-items: center; gap: 22px; }
    .nav-phone { font-family: 'Lato', sans-serif; font-size: 14px; font-weight: 700; color: var(--navy); text-decoration: none; }
    .nav-phone:hover { color: var(--red); }
    .btn-red { background: var(--red); color: #fff; font-family: 'Lato', sans-serif; font-weight: 900; font-size: 12px; letter-spacing: 0.10em; text-transform: uppercase; padding: 11px 22px; border: none; cursor: pointer; text-decoration: none; display: inline-block; }
    .btn-navy { background: var(--navy); color: #fff; font-family: 'Lato', sans-serif; font-weight: 900; font-size: 12px; letter-spacing: 0.10em; text-transform: uppercase; padding: 13px 28px; border: none; cursor: pointer; text-decoration: none; display: inline-block; }
    .btn-navy-outline { background: transparent; color: #fff; font-family: 'Lato', sans-serif; font-weight: 900; font-size: 12px; letter-spacing: 0.10em; text-transform: uppercase; padding: 13px 28px; border: 2px solid rgba(255,255,255,0.5); cursor: pointer; text-decoration: none; display: inline-block; }
    .hamburger { display: none; flex-direction: column; justify-content: center; gap: 5px; cursor: pointer; background: none; border: none; padding: 6px; }
    .hamburger span { display: block; width: 22px; height: 2px; background: var(--navy); }
    .hamburger.open span:nth-child(1) { transform: rotate(45deg) translate(5px, 5px); }
    .hamburger.open span:nth-child(2) { opacity: 0; width: 0; }
    .hamburger.open span:nth-child(3) { transform: rotate(-45deg) translate(5px, -5px); }
    .mobile-menu { display: none; position: fixed; top: 76px; left: 0; right: 0; z-index: 998; background: var(--white); border-bottom: 1px solid var(--border); flex-direction: column; }
    .mobile-menu.open { display: flex; }
    .mobile-menu a { font-family: 'Lato', sans-serif; font-size: 15px; font-weight: 700; color: var(--navy); text-decoration: none; padding: 16px 28px; border-bottom: 1px solid var(--border); }
    .mobile-menu .mobile-cta { background: var(--red); color: #fff; font-weight: 900; text-align: center; }
    .hero { min-height: 100vh; position: relative; display: flex; align-items: center; justify-content: center; text-align: center; padding: 120px 40px 90px; overflow: hidden; }
    .hero-bg { position: absolute; inset: 0; background-image: url('PLACEHOLDER_IMG/cemrecan-yurtman-F7deySfrKso-unsplash.jpg'); background-size: cover; background-position: center; filter: brightness(0.35) saturate(0.6); }
    .hero-grid { position: absolute; inset: 0; background-image: radial-gradient(circle, rgba(255,255,255,0.07) 1px, transparent 1px); background-size: 32px 32px; }
    .hero-overlay { position: absolute; inset: 0; background: linear-gradient(175deg, rgba(14,37,64,0.80) 0%, rgba(14,37,64,0.55) 100%); }
    .hero-content { position: relative; z-index: 1; max-width: 820px; }
    .hero-badge { display: inline-flex; align-items: center; gap: 10px; background: var(--red); color: #fff; font-family: 'Lato', sans-serif; font-size: 11px; font-weight: 700; letter-spacing: 0.18em; text-transform: uppercase; padding: 7px 18px; margin-bottom: 28px; }
    .hero h1 { font-family: 'Playfair Display', serif; font-size: clamp(38px, 5.5vw, 76px); font-weight: 900; line-height: 1.08; color: #fff; margin-bottom: 22px; }
    .hero h1 em { color: #f0a000; font-style: italic; }
    .hero p { font-size: 18px; color: rgba(255,255,255,0.8); max-width: 580px; margin: 0 auto 44px; line-height: 1.75; font-weight: 300; }
    .hero-ctas { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; }
    .trust-bar { background: var(--cream-dark); border-bottom: 1px solid var(--border); padding: 18px 80px; display: flex; align-items: center; justify-content: center; gap: 52px; }
    .trust-item { display: flex; align-items: center; gap: 10px; font-family: 'Lato', sans-serif; font-size: 13px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: var(--navy); }
    .trust-item svg { width: 16px; height: 16px; color: var(--red); flex-shrink: 0; }
    .trust-divider { width: 1px; height: 22px; background: var(--border); }
    .why-us { padding: 96px 80px; background: var(--cream); }
    .why-us-header { margin-bottom: 56px; }
    .section-tag { font-family: 'Lato', sans-serif; font-size: 11px; font-weight: 900; letter-spacing: 0.20em; text-transform: uppercase; color: var(--red); margin-bottom: 10px; display: flex; align-items: center; gap: 12px; }
    .section-tag::before { content: ''; display: block; width: 28px; height: 2px; background: var(--red); }
    .why-us-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(30px, 3.5vw, 48px); font-weight: 800; color: var(--navy); line-height: 1.15; margin-top: 4px; }
    .why-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 28px; }
    .why-card { background: var(--white); padding: 40px 34px; border-bottom: 3px solid transparent; box-shadow: 0 2px 16px rgba(14,37,64,0.06); transition: transform 0.25s, box-shadow 0.25s, border-color 0.25s; }
    .why-card:hover { transform: translateY(-6px); box-shadow: 0 12px 40px rgba(14,37,64,0.13); border-bottom-color: var(--red); }
    .why-num { font-family: 'Playfair Display', serif; font-size: 48px; font-weight: 900; color: rgba(14,37,64,0.06); line-height: 1; margin-bottom: 14px; }
    .why-card h3 { font-family: 'Lato', sans-serif; font-size: 17px; font-weight: 900; color: var(--navy); margin-bottom: 10px; }
    .why-card p { font-size: 15px; color: var(--muted); line-height: 1.75; font-weight: 300; }
    .service-row { display: grid; grid-template-columns: 1fr 1fr; align-items: stretch; }
    .service-row.reverse .service-img { order: 2; }
    .service-row.reverse .service-text { order: 1; }
    .service-img { overflow: hidden; }
    .service-img img { width: 100%; height: 100%; min-height: 420px; object-fit: cover; display: block; transition: transform 0.6s; }
    .service-row:hover .service-img img { transform: scale(1.03); }
    .service-text { padding: 72px 64px; }
    .service-text.bg-cream { background: var(--cream); }
    .service-text.bg-white { background: var(--white); }
    .service-text h2 { font-family: 'Playfair Display', serif; font-size: clamp(26px, 3vw, 42px); font-weight: 800; color: var(--navy); line-height: 1.2; margin-bottom: 16px; margin-top: 8px; }
    .service-text p { font-size: 16px; color: var(--muted); line-height: 1.8; margin-bottom: 14px; font-weight: 300; }
    .service-list { list-style: none; margin-bottom: 30px; display: flex; flex-direction: column; gap: 9px; }
    .service-list li { font-size: 15px; color: var(--text); display: flex; align-items: center; gap: 10px; }
    .service-list li::before { content: ''; width: 7px; height: 7px; background: var(--red); flex-shrink: 0; }
    .stats { background: var(--cream-dark); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); padding: 56px 80px; display: grid; grid-template-columns: repeat(4, 1fr); }
    .stat { text-align: center; padding: 0 20px; border-right: 1px solid var(--border); }
    .stat:last-child { border-right: none; }
    .stat-number { font-family: 'Playfair Display', serif; font-size: 56px; font-weight: 900; color: var(--navy); line-height: 1; margin-bottom: 8px; }
    .stat-label { font-family: 'Lato', sans-serif; font-size: 12px; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase; color: var(--muted); }
    .cta-banner { background: var(--navy); padding: 86px 80px; display: flex; align-items: center; justify-content: space-between; gap: 48px; position: relative; overflow: hidden; }
    .cta-banner::before { content: ''; position: absolute; top: -80px; right: -80px; width: 360px; height: 360px; border-radius: 50%; background: rgba(255,255,255,0.03); }
    .cta-banner h2 { font-family: 'Playfair Display', serif; font-size: clamp(24px, 3vw, 40px); font-weight: 800; color: #fff; line-height: 1.25; max-width: 600px; position: relative; z-index: 1; }
    .cta-banner h2 span { color: #f0a000; font-style: italic; }
    .btn-white { background: #fff; color: var(--navy); font-family: 'Lato', sans-serif; font-weight: 900; font-size: 12px; letter-spacing: 0.10em; text-transform: uppercase; padding: 16px 32px; border: none; cursor: pointer; text-decoration: none; display: inline-block; white-space: nowrap; position: relative; z-index: 1; }
    .contact { padding: 100px 80px; background: var(--white); }
    .contact-inner { max-width: 1120px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1.4fr; gap: 80px; align-items: start; }
    .contact-info h2 { font-family: 'Playfair Display', serif; font-size: clamp(28px, 3vw, 44px); font-weight: 800; color: var(--navy); line-height: 1.18; margin-bottom: 16px; margin-top: 8px; }
    .contact-info p { font-size: 16px; color: var(--muted); line-height: 1.8; margin-bottom: 34px; font-weight: 300; }
    .contact-details { display: flex; flex-direction: column; gap: 18px; }
    .contact-item { display: flex; align-items: flex-start; gap: 14px; }
    .contact-item-icon { width: 38px; height: 38px; background: var(--cream); border: 1px solid var(--border); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .contact-item-icon svg { width: 16px; height: 16px; color: var(--navy); }
    .contact-item-text strong { display: block; font-family: 'Lato', sans-serif; font-size: 11px; font-weight: 900; color: var(--navy); letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 2px; }
    .contact-item-text a, .contact-item-text span { font-size: 14px; color: var(--muted); text-decoration: none; font-weight: 300; }
    .contact-form { background: var(--cream); padding: 44px; border: 1px solid var(--border); display: flex; flex-direction: column; gap: 16px; }
    .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
    .field label { display: block; font-family: 'Lato', sans-serif; font-size: 11px; font-weight: 900; letter-spacing: 0.12em; text-transform: uppercase; color: var(--navy); margin-bottom: 7px; }
    .field input, .field textarea, .field select { width: 100%; background: var(--white); border: 1px solid var(--border); color: var(--text); font-family: 'Lato', sans-serif; font-size: 15px; font-weight: 300; padding: 12px 14px; outline: none; appearance: none; }
    .field input::placeholder, .field textarea::placeholder { color: #bdb5aa; }
    .field textarea { resize: vertical; min-height: 112px; }
    .btn-submit { background: var(--navy); color: #fff; font-family: 'Lato', sans-serif; font-weight: 900; font-size: 13px; letter-spacing: 0.10em; text-transform: uppercase; padding: 16px; border: none; cursor: pointer; width: 100%; }
    footer { background: var(--navy-dark); padding: 60px 80px 36px; }
    .footer-top { display: grid; grid-template-columns: 1.3fr 1fr 1fr; gap: 52px; margin-bottom: 52px; padding-bottom: 52px; border-bottom: 1px solid rgba(255,255,255,0.08); }
    .footer-brand img { height: 40px; margin-bottom: 16px; filter: brightness(0) invert(1); }
    .footer-brand-text { font-family: 'Playfair Display', serif; font-size: 20px; font-weight: 800; color: #fff; margin-bottom: 14px; }
    .footer-brand p { font-size: 14px; color: rgba(255,255,255,0.65); line-height: 1.75; max-width: 280px; font-weight: 300; }
    .footer-col h4 { font-family: 'Lato', sans-serif; font-size: 11px; font-weight: 900; letter-spacing: 0.16em; text-transform: uppercase; color: rgba(255,255,255,0.5); margin-bottom: 18px; }
    .footer-col ul { list-style: none; display: flex; flex-direction: column; gap: 10px; }
    .footer-col ul li a { font-size: 14px; color: rgba(255,255,255,0.72); text-decoration: none; font-weight: 300; }
    .footer-col ul li span { font-size: 14px; color: rgba(255,255,255,0.65); font-weight: 300; }
    .footer-bottom { display: flex; justify-content: space-between; align-items: center; }
    .footer-bottom p { font-size: 12px; color: rgba(255,255,255,0.55); }
    @media (max-width: 900px) {
      nav { display: flex !important; justify-content: space-between; padding: 0 24px; }
      .nav-links { display: none !important; }
      .nav-phone { display: none; }
      .hamburger { display: flex; }
      .hero { padding: 100px 28px 70px; }
      .trust-bar { padding: 14px 24px; gap: 20px; flex-wrap: wrap; }
      .trust-divider { display: none; }
      .why-us { padding: 70px 28px; }
      .why-grid { grid-template-columns: 1fr; gap: 20px; }
      .service-row { grid-template-columns: 1fr; }
      .service-row.reverse .service-img, .service-row.reverse .service-text { order: unset; }
      .service-img img { min-height: 260px; height: 260px; }
      .service-text { padding: 50px 28px; }
      .cta-banner { padding: 60px 28px; flex-direction: column; text-align: center; }
      .stats { grid-template-columns: 1fr 1fr; padding: 40px 28px; gap: 0; }
      .stat { border-right: none; border-bottom: 1px solid var(--border); padding: 20px; }
      .contact { padding: 70px 28px; }
      .contact-inner { grid-template-columns: 1fr; gap: 48px; }
      .contact-form { padding: 28px; }
      footer { padding: 50px 28px 28px; }
      .footer-top { grid-template-columns: 1fr; gap: 32px; }
      .footer-bottom { flex-direction: column; gap: 8px; text-align: center; }
      .form-row { grid-template-columns: 1fr; }
    }
  </style>
</head>
<body>
  <nav id="nav">
    PLACEHOLDER_NAV_LOGO
    <ul class="nav-links">
      <li><a href="#">Home</a></li>
      <li><a href="#about">About</a></li>
      <li><a href="#services">Services</a></li>
      <li><a href="#contact">Contact</a></li>
    </ul>
    <div class="nav-right">
      <a href="tel:PLACEHOLDER_PHONE_DIGITS" class="nav-phone">PLACEHOLDER_PHONE</a>
      <button class="hamburger" id="hamburger" aria-label="Open menu"><span></span><span></span><span></span></button>
      <a href="#contact" class="btn-red">Free Quote</a>
    </div>
  </nav>
  <div class="mobile-menu" id="mobile-menu">
    <a href="#">Home</a>
    <a href="#about">About</a>
    <a href="#services">Services</a>
    <a href="#contact">Contact</a>
    <a href="#contact" class="mobile-cta">Free Quote</a>
  </div>
  <section class="hero">
    <div class="hero-bg"></div>
    <div class="hero-grid"></div>
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <div class="hero-badge anim-1">PLACEHOLDER_HERO_EYEBROW</div>
      <h1 class="anim-2">PLACEHOLDER_HERO_H1</h1>
      <p class="anim-3">PLACEHOLDER_HERO_TAGLINE</p>
      <div class="hero-ctas anim-4">
        <a href="#contact" class="btn-navy">Get a Free Quote</a>
        <a href="#services" class="btn-navy-outline">View Services</a>
      </div>
    </div>
  </section>
  <div class="trust-bar">
    <div class="trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>On-Time Delivery</div>
    <div class="trust-divider"></div>
    <div class="trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/></svg>&#177;0.001&quot; Tolerances</div>
    <div class="trust-divider"></div>
    <div class="trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg>Made in Ohio</div>
    <div class="trust-divider"></div>
    <div class="trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>24-Hour Quotes</div>
  </div>
  <section class="why-us" id="about">
    <div class="why-us-header">
      <div class="section-tag">Why Choose Us</div>
      <h2>The Shop That Gets It Right</h2>
    </div>
    <div class="why-grid">
      PLACEHOLDER_SERVICE_CARDS_T2
    </div>
  </section>
  <section id="services">
    <div class="service-row">
      <div class="service-img"><img src="PLACEHOLDER_IMG/jelifer-maniago-O5rSp_U-Pa0-unsplash.jpg" alt="CNC Milling"></div>
      <div class="service-text bg-cream">
        <div class="section-tag">Service 01</div>
        <h2>CNC Milling &amp; Turning</h2>
        <p>From simple flanges to complex multi-surface components, our CNC operations deliver precise, repeatable results across a wide range of materials.</p>
        <ul class="service-list"><li>3-axis and 4-axis CNC milling</li><li>CNC turning with live tooling</li><li>Aluminum, steel, stainless, titanium, plastics</li><li>Tolerances to &#177;0.001&quot;</li></ul>
        <a href="#contact" class="btn-navy">Request a Quote</a>
      </div>
    </div>
    <div class="service-row reverse">
      <div class="service-img"><img src="PLACEHOLDER_IMG/pexels-optlasers-7097290.jpg" alt="Metal Fabrication"></div>
      <div class="service-text bg-white">
        <div class="section-tag">Service 02</div>
        <h2>Metal Fabrication &amp; Finishing</h2>
        <p>We handle the full production workflow — from cutting and forming through welding, assembly, and surface finishing — so you receive a complete, ready-to-install part.</p>
        <ul class="service-list"><li>Laser cutting and plasma cutting</li><li>Press brake forming and bending</li><li>MIG and TIG welding</li><li>Powder coat, anodize, and plating referrals</li></ul>
        <a href="#contact" class="btn-navy">Request a Quote</a>
      </div>
    </div>
  </section>
  <div class="stats">
    <div class="stat"><div class="stat-number">25+</div><div class="stat-label">Years in Business</div></div>
    <div class="stat"><div class="stat-number">10K+</div><div class="stat-label">Parts Delivered</div></div>
    <div class="stat"><div class="stat-number">&#177;.001&quot;</div><div class="stat-label">Tolerance Held</div></div>
    <div class="stat"><div class="stat-number">100%</div><div class="stat-label">On-Time Delivery</div></div>
  </div>
  <div class="cta-banner">
    <h2>Ready to get started? We'll have a quote back to you <span>within 24 hours.</span></h2>
    <a href="#contact" class="btn-white">Get a Free Quote</a>
  </div>
  <section class="contact" id="contact">
    <div class="contact-inner">
      <div class="contact-info">
        <div class="section-tag">Contact Us</div>
        <h2>Let's Talk About Your Project</h2>
        <p>Send us your print, CAD file, or a description of your part. We'll review it and come back with a quote and realistic lead time.</p>
        <div class="contact-details">
          <div class="contact-item"><div class="contact-item-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11 19.79 19.79 0 012 2.18 2 2 0 014 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16z"/></svg></div><div class="contact-item-text"><strong>Phone</strong><a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a></div></div>
          <div class="contact-item"><div class="contact-item-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></div><div class="contact-item-text"><strong>Email</strong><a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a></div></div>
          <div class="contact-item"><div class="contact-item-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg></div><div class="contact-item-text"><strong>Location</strong><span>PLACEHOLDER_ADDRESS</span></div></div>
        </div>
      </div>
      <form class="contact-form">
        <div class="form-row">
          <div class="field"><label>First Name</label><input type="text" placeholder="John"></div>
          <div class="field"><label>Last Name</label><input type="text" placeholder="Smith"></div>
        </div>
        <div class="field"><label>Company</label><input type="text" placeholder="Your Company"></div>
        <div class="form-row">
          <div class="field"><label>Phone</label><input type="tel" placeholder="330-000-0000"></div>
          <div class="field"><label>Email</label><input type="email" placeholder="you@company.com"></div>
        </div>
        <div class="field"><label>Project Details</label><textarea placeholder="Describe your part, material, quantity, and tolerances..."></textarea></div>
        <button type="button" class="btn-submit">Send My Quote Request &rarr;</button>
      </form>
    </div>
  </section>
  <footer>
    <div class="footer-top">
      <div class="footer-brand">PLACEHOLDER_FOOTER_LOGO_T2<p>Precision CNC machining and metal fabrication serving Northeast Ohio.</p></div>
      <div class="footer-col"><h4>Services</h4><ul><li><a href="#services">CNC Milling</a></li><li><a href="#services">CNC Turning</a></li><li><a href="#services">Metal Fabrication</a></li><li><a href="#contact">Request a Quote</a></li></ul></div>
      <div class="footer-col"><h4>Contact</h4><ul><li><a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a></li><li><a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a></li><li><span>PLACEHOLDER_ADDRESS</span></li></ul></div>
    </div>
    <div class="footer-bottom">
      <p>&copy; 2025 PLACEHOLDER_COMPANY. All rights reserved.</p>
      <p>Serving Northeast Ohio</p>
    </div>
  </footer>
  <script>
    var hamburger = document.getElementById('hamburger');
    var mobileMenu = document.getElementById('mobile-menu');
    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function() { hamburger.classList.toggle('open'); mobileMenu.classList.toggle('open'); });
      mobileMenu.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', function() { hamburger.classList.remove('open'); mobileMenu.classList.remove('open'); }); });
    }
  </script>
</body>
</html>`;

const T3 = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="robots" content="noindex, nofollow">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>PLACEHOLDER_COMPANY | High-Precision CNC Manufacturing</title>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link href="https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@300;400;500&family=IBM+Plex+Sans:wght@300;400;500;600&display=swap" rel="stylesheet">
  <style>
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    :root {
      --bg: #040c16; --surface: #080f1c; --card: #0c1625; --border: #132030;
      --cyan: #00cfe0; --cyan-dim: rgba(0,207,224,0.10);
      --white: #d8eaf5; --muted: #6a9abb; --text: #8ab8d4;
    }
    PLACEHOLDER_BRAND_COLORS_T3
    html { scroll-behavior: smooth; }
    body { background: var(--bg); color: var(--text); font-family: 'IBM Plex Sans', sans-serif; font-size: 16px; line-height: 1.65; }
    body::before { content: ''; position: fixed; inset: 0; background-image: radial-gradient(circle, rgba(0,207,224,0.06) 1px, transparent 1px); background-size: 28px 28px; pointer-events: none; z-index: 0; }
    @keyframes fadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
    .anim-1 { animation: fadeUp 0.85s cubic-bezier(0.22,1,0.36,1) 0.15s both; }
    .anim-2 { animation: fadeUp 0.85s cubic-bezier(0.22,1,0.36,1) 0.35s both; }
    .anim-3 { animation: fadeUp 0.85s cubic-bezier(0.22,1,0.36,1) 0.52s both; }
    .anim-4 { animation: fadeUp 0.85s cubic-bezier(0.22,1,0.36,1) 0.66s both; }
    nav { position: fixed; top: 0; left: 0; right: 0; z-index: 1000; background: rgba(4,12,22,0.90); backdrop-filter: blur(20px); border-bottom: 1px solid var(--border); padding: 0 52px; height: 76px; display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; }
    .nav-logo { justify-self: start; }
    .nav-logo img { height: 72px; width: auto; }
    .nav-logo-text { justify-self: start; font-family: 'Syne', sans-serif; font-size: 20px; font-weight: 800; color: var(--white); }
    .nav-center { display: flex; gap: 40px; list-style: none; justify-self: center; }
    .nav-center a { font-family: 'Syne', sans-serif; font-size: 12px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; color: var(--muted); text-decoration: none; position: relative; padding-bottom: 4px; }
    .nav-center a::after { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 1px; background: var(--cyan); transform: scaleX(0); transform-origin: left; transition: transform 0.25s ease; }
    .nav-center a:hover, .nav-center a.active { color: var(--cyan); }
    .nav-center a:hover::after, .nav-center a.active::after { transform: scaleX(1); }
    .nav-right { justify-self: end; display: flex; align-items: center; gap: 22px; }
    .nav-phone { font-family: 'IBM Plex Mono', monospace; font-size: 13px; color: var(--muted); text-decoration: none; }
    .nav-phone:hover { color: var(--cyan); }
    .btn-cyan { background: var(--cyan); color: #000; font-family: 'Syne', sans-serif; font-weight: 700; font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; padding: 11px 22px; border: none; cursor: pointer; text-decoration: none; display: inline-block; }
    .btn-cyan-outline { background: transparent; color: var(--cyan); font-family: 'Syne', sans-serif; font-weight: 700; font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; padding: 13px 28px; border: 1px solid rgba(0,207,224,0.4); cursor: pointer; text-decoration: none; display: inline-block; }
    .hamburger { display: none; flex-direction: column; justify-content: center; gap: 5px; cursor: pointer; background: none; border: none; padding: 6px; }
    .hamburger span { display: block; width: 22px; height: 2px; background: var(--cyan); }
    .hamburger.open span:nth-child(1) { transform: rotate(45deg) translate(5px, 5px); }
    .hamburger.open span:nth-child(2) { opacity: 0; width: 0; }
    .hamburger.open span:nth-child(3) { transform: rotate(-45deg) translate(5px, -5px); }
    .mobile-menu { display: none; position: fixed; top: 76px; left: 0; right: 0; z-index: 998; background: rgba(4,12,22,0.99); border-bottom: 1px solid var(--border); flex-direction: column; backdrop-filter: blur(16px); }
    .mobile-menu.open { display: flex; }
    .mobile-menu a { font-family: 'Syne', sans-serif; font-size: 15px; font-weight: 600; letter-spacing: 0.06em; text-transform: uppercase; color: var(--text); text-decoration: none; padding: 16px 28px; border-bottom: 1px solid var(--border); }
    .mobile-menu .mobile-cta { background: var(--cyan); color: #000; font-weight: 700; text-align: center; }
    .hero { min-height: 100vh; display: grid; grid-template-columns: 1fr 1fr; padding-top: 76px; position: relative; z-index: 1; }
    .hero-left { background: var(--bg); display: flex; align-items: center; padding: 80px 72px 80px 80px; }
    .hero-content { max-width: 520px; }
    .hero-tag { font-family: 'IBM Plex Mono', monospace; font-size: 11px; font-weight: 400; letter-spacing: 0.18em; text-transform: uppercase; color: var(--cyan); margin-bottom: 22px; display: flex; align-items: center; gap: 14px; }
    .hero-tag::before { content: '//'; font-size: 14px; opacity: 0.5; }
    .hero h1 { font-family: 'Syne', sans-serif; font-size: clamp(38px, 4.5vw, 64px); font-weight: 800; line-height: 1.06; color: var(--white); letter-spacing: -0.01em; margin-bottom: 24px; }
    .hero h1 span { color: var(--cyan); }
    .hero p { font-size: 16px; color: var(--text); line-height: 1.82; margin-bottom: 42px; max-width: 420px; font-weight: 300; }
    .hero-ctas { display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 40px; }
    .hero-specs { display: flex; gap: 28px; padding-top: 28px; border-top: 1px solid var(--border); }
    .hero-spec-val { font-family: 'IBM Plex Mono', monospace; font-size: 22px; font-weight: 500; color: var(--cyan); line-height: 1; margin-bottom: 4px; }
    .hero-spec-label { font-size: 11px; color: var(--muted); letter-spacing: 0.08em; text-transform: uppercase; font-family: 'IBM Plex Mono', monospace; }
    .hero-right { position: relative; overflow: hidden; }
    .hero-right img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; filter: brightness(0.45) saturate(0.3); }
    .hero-right::after { content: ''; position: absolute; inset: 0; background: linear-gradient(90deg, var(--bg) 0%, transparent 12%), linear-gradient(0deg, var(--bg) 0%, transparent 25%); }
    .hero-hud { position: absolute; inset: 24px; z-index: 2; pointer-events: none; }
    .hud-corner { position: absolute; width: 20px; height: 20px; border-color: rgba(0,207,224,0.4); border-style: solid; }
    .hud-tl { top: 0; left: 0; border-width: 1px 0 0 1px; }
    .hud-tr { top: 0; right: 0; border-width: 1px 1px 0 0; }
    .hud-bl { bottom: 0; left: 0; border-width: 0 0 1px 1px; }
    .hud-br { bottom: 0; right: 0; border-width: 0 1px 1px 0; }
    .hud-label { position: absolute; bottom: 8px; left: 50%; transform: translateX(-50%); font-family: 'IBM Plex Mono', monospace; font-size: 10px; letter-spacing: 0.18em; text-transform: uppercase; color: rgba(0,207,224,0.5); }
    .services { padding: 100px 80px; background: var(--surface); position: relative; z-index: 1; }
    .section-tag { font-family: 'IBM Plex Mono', monospace; font-size: 11px; font-weight: 400; letter-spacing: 0.20em; text-transform: uppercase; color: var(--cyan); margin-bottom: 8px; display: flex; align-items: center; gap: 12px; }
    .section-tag::before { content: '//'; opacity: 0.4; }
    .section-header { margin-bottom: 56px; }
    .section-header h2 { font-family: 'Syne', sans-serif; font-size: clamp(30px, 4vw, 54px); font-weight: 800; color: var(--white); line-height: 1.06; letter-spacing: -0.01em; margin-top: 8px; }
    .services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1px; background: var(--border); }
    .service-card { background: var(--card); padding: 42px 36px; position: relative; overflow: hidden; transition: background 0.25s; }
    .service-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px; background: linear-gradient(90deg, var(--cyan) 0%, transparent 100%); transform: scaleX(0); transform-origin: left; transition: transform 0.4s cubic-bezier(0.22,1,0.36,1); }
    .service-card:hover { background: #0e1d30; }
    .service-card:hover::before { transform: scaleX(1); }
    .service-num { font-family: 'IBM Plex Mono', monospace; font-size: 13px; font-weight: 400; color: var(--cyan); letter-spacing: 0.12em; margin-bottom: 16px; opacity: 0.6; }
    .service-card h3 { font-family: 'Syne', sans-serif; font-size: 18px; font-weight: 700; color: var(--white); letter-spacing: 0.02em; margin-bottom: 14px; }
    .service-card p { font-size: 14px; color: var(--muted); line-height: 1.82; margin-bottom: 20px; font-weight: 300; }
    .service-link { font-family: 'IBM Plex Mono', monospace; font-size: 11px; font-weight: 400; letter-spacing: 0.12em; text-transform: uppercase; color: var(--cyan); text-decoration: none; display: flex; align-items: center; gap: 8px; }
    .service-link::after { content: '&#8594;'; }
    .process { padding: 100px 80px; background: var(--bg); position: relative; z-index: 1; }
    .process-header { margin-bottom: 60px; }
    .process-steps { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; position: relative; }
    .process-line { position: absolute; top: 27px; left: calc(12.5% + 14px); right: calc(12.5% + 14px); height: 1px; background: var(--border); z-index: 0; }
    .step { text-align: center; padding: 0 24px; position: relative; z-index: 1; }
    .step-dot { width: 56px; height: 56px; background: var(--card); border: 1px solid var(--border); display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-family: 'IBM Plex Mono', monospace; font-size: 13px; font-weight: 500; color: var(--muted); }
    .step h4 { font-family: 'Syne', sans-serif; font-size: 14px; font-weight: 700; color: var(--white); letter-spacing: 0.04em; margin-bottom: 10px; }
    .step p { font-size: 13px; color: var(--muted); line-height: 1.7; font-weight: 300; }
    .about { position: relative; height: 540px; overflow: hidden; display: flex; align-items: center; z-index: 1; }
    .about-bg { position: absolute; inset: 0; }
    .about-bg img { width: 100%; height: 100%; object-fit: cover; filter: brightness(0.25) saturate(0.3); }
    .about-overlay { position: absolute; inset: 0; background: linear-gradient(90deg, rgba(4,12,22,0.97) 0%, rgba(4,12,22,0.80) 45%, rgba(4,12,22,0.2) 100%); }
    .about-content { position: relative; z-index: 1; padding: 0 80px; max-width: 680px; }
    .about-content h2 { font-family: 'Syne', sans-serif; font-size: clamp(28px, 3.5vw, 48px); font-weight: 800; color: var(--white); line-height: 1.1; margin-bottom: 20px; margin-top: 8px; }
    .about-stats { display: flex; gap: 40px; margin-bottom: 28px; }
    .about-stat-val { font-family: 'IBM Plex Mono', monospace; font-size: 32px; font-weight: 500; color: var(--cyan); line-height: 1; margin-bottom: 4px; }
    .about-stat-label { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: var(--muted); margin-top: 4px; letter-spacing: 0.08em; text-transform: uppercase; }
    .about-content p { font-size: 15px; color: var(--text); line-height: 1.85; margin-bottom: 28px; font-weight: 300; max-width: 520px; }
    .contact { padding: 100px 80px; background: var(--surface); display: grid; grid-template-columns: 1fr 1.2fr; gap: 80px; align-items: start; position: relative; z-index: 1; }
    .contact-info h2 { font-family: 'Syne', sans-serif; font-size: clamp(28px, 3vw, 44px); font-weight: 800; color: var(--white); letter-spacing: -0.01em; line-height: 1.1; margin-bottom: 18px; margin-top: 8px; }
    .contact-info p { font-size: 15px; color: var(--muted); line-height: 1.85; margin-bottom: 36px; font-weight: 300; }
    .contact-details { display: flex; flex-direction: column; gap: 20px; }
    .contact-item { display: flex; gap: 16px; align-items: flex-start; }
    .contact-item-icon { width: 40px; height: 40px; background: var(--cyan-dim); border: 1px solid rgba(0,207,224,0.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
    .contact-item-icon svg { width: 16px; height: 16px; color: var(--cyan); }
    .contact-item strong { display: block; font-family: 'IBM Plex Mono', monospace; font-size: 10px; font-weight: 500; letter-spacing: 0.14em; text-transform: uppercase; color: var(--cyan); margin-bottom: 4px; opacity: 0.8; }
    .contact-item a, .contact-item span { font-size: 14px; color: var(--text); text-decoration: none; font-weight: 300; }
    .contact-form { display: flex; flex-direction: column; gap: 14px; }
    .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
    .field label { display: block; font-family: 'IBM Plex Mono', monospace; font-size: 10px; font-weight: 500; letter-spacing: 0.18em; text-transform: uppercase; color: var(--muted); margin-bottom: 7px; }
    .field input, .field textarea, .field select { width: 100%; background: var(--card); border: 1px solid var(--border); color: var(--white); font-family: 'IBM Plex Sans', sans-serif; font-size: 14px; font-weight: 300; padding: 12px 14px; outline: none; appearance: none; }
    .field input::placeholder, .field textarea::placeholder { color: #2e4a64; }
    .field textarea { resize: vertical; min-height: 112px; }
    .btn-submit { background: var(--cyan); color: #000; font-family: 'Syne', sans-serif; font-weight: 700; font-size: 13px; letter-spacing: 0.12em; text-transform: uppercase; padding: 16px; border: none; cursor: pointer; width: 100%; }
    footer { background: #020810; border-top: 1px solid var(--border); padding: 52px 80px 32px; position: relative; z-index: 1; }
    .footer-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 48px; margin-bottom: 40px; padding-bottom: 40px; border-bottom: 1px solid var(--border); flex-wrap: wrap; }
    .footer-brand img { height: 36px; margin-bottom: 14px; }
    .footer-brand-text { font-family: 'Syne', sans-serif; font-size: 18px; font-weight: 800; color: var(--white); margin-bottom: 12px; }
    .footer-brand p { font-size: 13px; color: var(--muted); line-height: 1.75; max-width: 260px; font-weight: 300; }
    .footer-links h4 { font-family: 'IBM Plex Mono', monospace; font-size: 10px; font-weight: 500; letter-spacing: 0.18em; text-transform: uppercase; color: var(--muted); margin-bottom: 16px; }
    .footer-links ul { list-style: none; display: flex; flex-direction: column; gap: 9px; }
    .footer-links ul a { font-size: 13px; color: rgba(138,184,212,0.75); text-decoration: none; font-weight: 300; }
    .footer-bottom { display: flex; justify-content: space-between; align-items: center; }
    .footer-bottom p { font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: #4a7090; }
    @media (max-width: 1000px) {
      .hero { grid-template-columns: 1fr; min-height: auto; }
      .hero-right { height: 280px; position: relative; }
      .hero-left { padding: 80px 28px 60px; }
      nav { display: flex !important; justify-content: space-between; padding: 0 24px; }
      .nav-center { display: none !important; }
      .nav-phone { display: none; }
      .hamburger { display: flex; }
      .services { padding: 70px 28px; }
      .services-grid { grid-template-columns: 1fr; background: none; gap: 1px; }
      .process { padding: 70px 28px; }
      .process-steps { grid-template-columns: 1fr 1fr; gap: 36px; }
      .process-line { display: none; }
      .about { height: auto; padding: 70px 0; }
      .about-content { padding: 0 28px; max-width: 100%; }
      .contact { padding: 70px 28px; grid-template-columns: 1fr; gap: 48px; }
      footer { padding: 40px 28px 24px; }
      .footer-top { flex-direction: column; gap: 28px; }
      .footer-bottom { flex-direction: column; gap: 8px; text-align: center; }
      .form-row { grid-template-columns: 1fr; }
    }
  </style>
</head>
<body>
  <nav>
    PLACEHOLDER_NAV_LOGO
    <ul class="nav-center">
      <li><a href="#">Home</a></li>
      <li><a href="#about">About</a></li>
      <li><a href="#services">Services</a></li>
      <li><a href="#contact">Contact</a></li>
    </ul>
    <div class="nav-right">
      <a href="tel:PLACEHOLDER_PHONE_DIGITS" class="nav-phone">PLACEHOLDER_PHONE</a>
      <button class="hamburger" id="hamburger" aria-label="Open menu"><span></span><span></span><span></span></button>
      <a href="#contact" class="btn-cyan">Get a Quote</a>
    </div>
  </nav>
  <div class="mobile-menu" id="mobile-menu">
    <a href="#">Home</a>
    <a href="#about">About</a>
    <a href="#services">Services</a>
    <a href="#contact">Contact</a>
    <a href="#contact" class="mobile-cta">Get a Quote</a>
  </div>
  <section class="hero">
    <div class="hero-left">
      <div class="hero-content">
        <div class="hero-tag anim-1">PLACEHOLDER_HERO_EYEBROW</div>
        <h1 class="anim-2">PLACEHOLDER_HERO_H1</h1>
        <p class="anim-3">PLACEHOLDER_HERO_TAGLINE</p>
        <div class="hero-ctas anim-4">
          <a href="#contact" class="btn-cyan">Request a Quote</a>
          <a href="#services" class="btn-cyan-outline">Our Capabilities</a>
        </div>
        <div class="hero-specs anim-4">
          <div><div class="hero-spec-val">&#177;.001&quot;</div><div class="hero-spec-label">Tolerance</div></div>
          <div><div class="hero-spec-val">25+</div><div class="hero-spec-label">Years Running</div></div>
          <div><div class="hero-spec-val">24H</div><div class="hero-spec-label">Quote Turnaround</div></div>
        </div>
      </div>
    </div>
    <div class="hero-right">
      <img src="PLACEHOLDER_IMG/sven-daniel-DV_rG1mjDxs-unsplash.jpg" alt="Precision CNC lathe machining">
      <div class="hero-hud">
        <div class="hud-corner hud-tl"></div>
        <div class="hud-corner hud-tr"></div>
        <div class="hud-corner hud-bl"></div>
        <div class="hud-corner hud-br"></div>
        <div class="hud-label">// LIVE MACHINING</div>
      </div>
    </div>
  </section>
  <section class="services" id="services">
    <div class="section-header">
      <div class="section-tag">Capabilities</div>
      <h2>What We Machine</h2>
    </div>
    <div class="services-grid">
      PLACEHOLDER_SERVICE_CARDS_T3
    </div>
  </section>
  <section class="process" id="process">
    <div class="process-header">
      <div class="section-tag">How It Works</div>
      <h2 style="font-family:'Syne',sans-serif;font-size:clamp(30px,4vw,54px);font-weight:800;color:var(--white);line-height:1.06;margin-top:8px;">From Quote<br>to Delivery</h2>
    </div>
    <div class="process-steps">
      <div class="process-line"></div>
      <div class="step"><div class="step-dot">01</div><h4>Submit Your Print</h4><p>Send us your CAD file, PDF print, or a description of your part.</p></div>
      <div class="step"><div class="step-dot">02</div><h4>Quote &amp; Review</h4><p>We'll review for manufacturability and send back a quote within 24 hours.</p></div>
      <div class="step"><div class="step-dot">03</div><h4>Machining</h4><p>Your part goes into production with full QC at each stage.</p></div>
      <div class="step"><div class="step-dot">04</div><h4>Ship or Pick Up</h4><p>Parts ship or are available for pickup — on the date we committed to.</p></div>
    </div>
  </section>
  <section class="about" id="about">
    <div class="about-bg"><img src="PLACEHOLDER_IMG/pexels-shkrabaanthony-6620985.jpg" alt="Machine shop floor"></div>
    <div class="about-overlay"></div>
    <div class="about-content">
      <div class="section-tag">About Us</div>
      <h2>Northeast Ohio's<br>Precision Shop</h2>
      <div class="about-stats">
        <div><div class="about-stat-val">25+</div><div class="about-stat-label">Years Running</div></div>
        <div><div class="about-stat-val">10K+</div><div class="about-stat-label">Parts Made</div></div>
        <div><div class="about-stat-val">&#177;.001&quot;</div><div class="about-stat-label">Tolerances</div></div>
      </div>
      <p>PLACEHOLDER_ABOUT_PARA</p>
      <a href="#contact" class="btn-cyan">Start a Project</a>
    </div>
  </section>
  <section class="contact" id="contact">
    <div class="contact-info">
      <div class="section-tag">Get in Touch</div>
      <h2>Let's Build<br>Your Part</h2>
      <p>Send us your print or describe the job. We'll get back to you within one business day with a quote and a realistic lead time.</p>
      <div class="contact-details">
        <div class="contact-item"><div class="contact-item-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 11 19.79 19.79 0 012 2.18 2 2 0 014 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16z"/></svg></div><div><strong>Phone</strong><a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a></div></div>
        <div class="contact-item"><div class="contact-item-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></div><div><strong>Email</strong><a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a></div></div>
        <div class="contact-item"><div class="contact-item-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg></div><div><strong>Location</strong><span>PLACEHOLDER_ADDRESS</span></div></div>
        <div class="contact-item"><div class="contact-item-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></div><div><strong>Hours</strong><span>Mon&#8211;Fri: 7:00 AM &#8211; 5:00 PM</span></div></div>
      </div>
    </div>
    <form class="contact-form">
      <div class="form-row">
        <div class="field"><label>First Name</label><input type="text" placeholder="John"></div>
        <div class="field"><label>Last Name</label><input type="text" placeholder="Smith"></div>
      </div>
      <div class="field"><label>Company</label><input type="text" placeholder="Your Company"></div>
      <div class="form-row">
        <div class="field"><label>Phone</label><input type="tel" placeholder="330-000-0000"></div>
        <div class="field"><label>Email</label><input type="email" placeholder="you@company.com"></div>
      </div>
      <div class="field"><label>Project Details</label><textarea placeholder="Describe your part, material, quantity, tolerance requirements, and deadline..."></textarea></div>
      <button type="button" class="btn-submit">Send Quote Request &rarr;</button>
    </form>
  </section>
  <footer>
    <div class="footer-top">
      <div class="footer-brand">PLACEHOLDER_FOOTER_LOGO_T3<p>High-precision CNC machining and fabrication. Serving Northeast Ohio.</p></div>
      <div class="footer-links"><h4>Services</h4><ul><li><a href="#services">CNC Milling</a></li><li><a href="#services">CNC Turning</a></li><li><a href="#services">Metal Fabrication</a></li></ul></div>
      <div class="footer-links"><h4>Contact</h4><ul><li><a href="tel:PLACEHOLDER_PHONE_DIGITS">PLACEHOLDER_PHONE</a></li><li><a href="mailto:PLACEHOLDER_EMAIL">PLACEHOLDER_EMAIL</a></li><li><a href="#">PLACEHOLDER_ADDRESS</a></li></ul></div>
    </div>
    <div class="footer-bottom">
      <p>&copy; 2025 PLACEHOLDER_COMPANY. All rights reserved.</p>
      <p>// Northeast Ohio</p>
    </div>
  </footer>
  <script>
    var hamburger = document.getElementById('hamburger');
    var mobileMenu = document.getElementById('mobile-menu');
    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function() { hamburger.classList.toggle('open'); mobileMenu.classList.toggle('open'); });
      mobileMenu.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', function() { hamburger.classList.remove('open'); mobileMenu.classList.remove('open'); }); });
    }
  </script>
</body>
</html>`;

// ── Color utilities ──────────────────────────────────────────────────────────
function hexToHsl(hex) {
  const r = parseInt(hex.slice(1,3),16)/255, g = parseInt(hex.slice(3,5),16)/255, b = parseInt(hex.slice(5,7),16)/255;
  const max = Math.max(r,g,b), min = Math.min(r,g,b);
  let h, s, l = (max+min)/2;
  if (max === min) { h = s = 0; } else {
    const d = max - min;
    s = l > 0.5 ? d/(2-max-min) : d/(max+min);
    switch(max) {
      case r: h = ((g-b)/d + (g<b?6:0))/6; break;
      case g: h = ((b-r)/d + 2)/6; break;
      default: h = ((r-g)/d + 4)/6;
    }
  }
  return [Math.round(h*360), Math.round(s*100), Math.round(l*100)];
}

function hslToHex(h, s, l) {
  s /= 100; l /= 100;
  const k = n => (n + h/30) % 12;
  const a = s * Math.min(l, 1-l);
  const f = n => l - a*Math.max(-1, Math.min(k(n)-3, Math.min(9-k(n), 1)));
  return '#' + [f(0),f(8),f(4)].map(x => Math.round(x*255).toString(16).padStart(2,'0')).join('');
}

function adjustLightness(hex, delta) {
  const [h, s, l] = hexToHsl(hex);
  return hslToHex(h, s, Math.max(0, Math.min(100, l + delta)));
}

function buildBrandColors(colors, templateNum) {
  if (!colors || !colors.primary) return '';
  const p = colors.primary;
  const pLight = adjustLightness(p, 15);
  const pDark = adjustLightness(p, -15);
  const a = colors.accent || adjustLightness(p, -25);
  const aDark = adjustLightness(a, -15);
  // T1 now uses --forge / --forge-bright
  if (templateNum === 1) return `:root { --forge: ${p}; --forge-bright: ${pLight}; }`;
  // T2 still uses --navy / --red
  if (templateNum === 2) return `:root { --navy: ${p}; --navy-dark: ${pDark}; --red: ${a}; --red-dark: ${aDark}; }`;
  // T3 now uses --cyan
  if (templateNum === 3) return `:root { --cyan: ${p}; }`;
  return '';
}

// Default service cards per template (fallback when AI copy is unavailable)
const DEFAULT_SERVICES = [
  { name: 'CNC Milling', desc: '3-axis and 4-axis milling for complex geometries. Tolerances to ±0.001" on aluminum, steel, stainless, and exotic alloys.' },
  { name: 'CNC Turning', desc: 'High-speed lathe turning for round and cylindrical components. Live tooling available for milled features in a single setup.' },
  { name: 'Metal Fabrication', desc: 'Laser cutting, bending, welding, and finishing. Full assemblies from raw material to ready-to-install components.' },
];

function buildServiceCardsT1(services) {
  return services.map((s, i) =>
    `<div class="service-card"><div class="service-num">${String(i + 1).padStart(2, '0')}</div><h3>${s.name}</h3><p>${s.desc}</p></div>`
  ).join('\n      ');
}

function buildServiceCardsT2(services) {
  return services.map((s, i) =>
    `<div class="why-card"><div class="why-num">${String(i + 1).padStart(2, '0')}</div><h3>${s.name}</h3><p>${s.desc}</p></div>`
  ).join('\n      ');
}

function buildServiceCardsT3(services) {
  return services.map((s, i) =>
    `<div class="service-card"><div class="service-num">// ${String(i + 1).padStart(2, '0')}</div><h3>${s.name}</h3><p>${s.desc}</p><a href="#contact" class="service-link">Request a Quote</a></div>`
  ).join('\n      ');
}

// Default copy per template
const DEFAULT_COPY = {
  1: { eyebrow: 'CNC Machining &amp; Metal Fabrication', headline: 'Precision<br><em>Machined.</em><br>Every Time.', tagline: 'Tight-tolerance parts for aerospace, automotive, and industrial clients. Prototype to production — built right, delivered on time.', about: 'COMPANY_NAME has been manufacturing high-quality precision parts for over two decades. We work with engineers and procurement teams across the region to deliver parts that meet spec — every time.' },
  2: { eyebrow: "Northeast Ohio's Precision Machining Shop", headline: 'Your Trusted<br><em>Machining Partner</em>', tagline: 'Custom CNC machining and metal fabrication for manufacturers, engineers, and procurement teams across the region.', about: null },
  3: { eyebrow: 'Precision CNC Manufacturing', headline: 'Precision Is<br>Not an Option.<br>It\'s a <span>Standard.</span>', tagline: "High-tolerance CNC machining for manufacturers and engineers who can't afford to get it wrong. From first article to full production run.", about: 'We run modern CNC equipment and an experienced crew that takes quality seriously. Producing precision parts for regional manufacturers for over two decades.' },
};

export function generateMockup(templateNum, data) {
  // Dispatch to industry-specific generators
  if (templateNum === 4 || templateNum === 5) return generateHVACMockup(templateNum, data);
  if (templateNum === 6 || templateNum === 7) return generateRoofingMockup(templateNum, data);
  if (templateNum === 8 || templateNum === 9) return generateAutomotiveMockup(templateNum, data);
  if (templateNum === 10) return generateLandscapingMockup(templateNum, data);
  if (templateNum === 11) return generateElectricalMockup(templateNum, data);

  const TEMPLATES = [T1, T2, T3];
  let html = TEMPLATES[(templateNum - 1) % 3];

  const company = (data.company || 'Your Company').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const phone = data.phone || '330-000-0000';
  const phoneDigits = phone.replace(/\D/g, '');
  const email = data.email || 'contact@yourcompany.com';
  const address = data.address || 'Northeast Ohio';
  const logoUrl = data.logoUrl;
  const copy = data.copy;
  const defaults = DEFAULT_COPY[templateNum] || DEFAULT_COPY[1];

  // Brand color overrides
  html = html.replace('PLACEHOLDER_BRAND_COLORS_T1', buildBrandColors(data.colors, 1));
  html = html.replace('PLACEHOLDER_BRAND_COLORS_T2', buildBrandColors(data.colors, 2));
  html = html.replace('PLACEHOLDER_BRAND_COLORS_T3', buildBrandColors(data.colors, 3));

  // Replace image base URL placeholder
  html = html.replace(/PLACEHOLDER_IMG/g, IMAGES);

  // Build nav logo HTML
  const navLogoHtml = logoUrl
    ? `<div class="nav-logo"><img src="${logoUrl}" alt="${company}" style="max-height:52px;width:auto;"></div>`
    : `<div class="nav-logo-text">${company}</div>`;

  html = html.replace('PLACEHOLDER_NAV_LOGO', navLogoHtml);

  // Build footer logos per template
  const t1FooterLogo = logoUrl
    ? `<img src="${logoUrl}" alt="${company}" style="height:34px;width:auto;">`
    : `<span class="footer-logo-text">${company}</span>`;
  const t2FooterLogo = logoUrl
    ? `<img src="${logoUrl}" alt="${company}" style="height:36px;width:auto;margin-bottom:14px;filter:brightness(0) invert(1);">`
    : `<div class="footer-brand-text">${company}</div>`;
  const t3FooterLogo = logoUrl
    ? `<img src="${logoUrl}" alt="${company}" style="height:32px;width:auto;margin-bottom:12px;">`
    : `<div class="footer-brand-text">${company}</div>`;

  html = html.replace('PLACEHOLDER_FOOTER_LOGO_T1', t1FooterLogo);
  html = html.replace('PLACEHOLDER_FOOTER_LOGO_T2', t2FooterLogo);
  html = html.replace('PLACEHOLDER_FOOTER_LOGO_T3', t3FooterLogo);

  // Copy replacements (AI-generated or defaults)
  const eyebrow = (copy && copy.eyebrow) || defaults.eyebrow;

  // Enforce max 8-word headline — truncate if model ignores instructions
  function clampHeadline(raw) {
    const lines = raw.split(/\\n|\n/).map(l => l.trim()).filter(Boolean).slice(0, 2);
    const words = lines.join(' ').split(/\s+/);
    if (words.length <= 8) return lines.join('\n');
    // Redistribute truncated words evenly across lines
    const kept = words.slice(0, 8);
    const mid = Math.ceil(kept.length / 2);
    return [kept.slice(0, mid).join(' '), kept.slice(mid).join(' ')].join('\n');
  }
  const rawHeadline = (copy && copy.headline) ? clampHeadline(copy.headline) : null;
  const headline = rawHeadline ? rawHeadline.replace(/\n/g, '<br>') : defaults.headline;
  const tagline = (copy && copy.tagline) || defaults.tagline;
  const aboutPara = (copy && copy.about) || (defaults.about ? defaults.about.replace('COMPANY_NAME', company) : `${company} has been delivering precision machined parts to manufacturers across the region for decades.`);

  html = html.replace('PLACEHOLDER_HERO_EYEBROW', eyebrow);
  html = html.replace('PLACEHOLDER_HERO_H1', headline);
  html = html.replace('PLACEHOLDER_HERO_TAGLINE', tagline);
  html = html.replace('PLACEHOLDER_ABOUT_PARA', aboutPara);

  // Service cards (AI-generated or defaults)
  const services = (copy && Array.isArray(copy.services) && copy.services.length >= 3)
    ? copy.services.slice(0, 3)
    : DEFAULT_SERVICES;
  html = html.replace('PLACEHOLDER_SERVICE_CARDS_T1', buildServiceCardsT1(services));
  html = html.replace('PLACEHOLDER_SERVICE_CARDS_T2', buildServiceCardsT2(services));
  html = html.replace('PLACEHOLDER_SERVICE_CARDS_T3', buildServiceCardsT3(services));

  // Text token replacement
  html = html.replace(/PLACEHOLDER_COMPANY/g, company);
  html = html.replace(/PLACEHOLDER_PHONE_DIGITS/g, phoneDigits);
  html = html.replace(/PLACEHOLDER_PHONE/g, phone);
  html = html.replace(/PLACEHOLDER_EMAIL/g, email);
  html = html.replace(/PLACEHOLDER_ADDRESS/g, address);

  return html;
}
